import { Theme } from '@emotion/react';

export const generateSearchStyles = (theme: Theme) => ({
    wrapper: {
        position: 'relative',
        width: '40%',
        margin: '0 auto',

        '& .searchInput': {
            paddingLeft: '30px',
            fontSize: '16px',
            height: '32px',
            fontFamily: theme.palette.common.font,
            boxSizing: 'border-box',
            '::placeholder': {
                color: theme.palette.secondary.skygrey,
                letterSpacing: '0.25px',
                fontSize: '16px',
                fontWeight: 400,
            },
        },
        '& .icon': {
            color: theme.palette.secondary.skygrey,
            position: 'absolute',
            top: '50%',
            left: '10px',
            transform: 'translateY(-50%)',
            width: '20px',
            height: '20px',
        },
        '& .clearIcon': {
            color: theme.palette.secondary.skygrey,
            position: 'absolute',
            top: '50%',
            right: '10px',
            transform: 'translateY(-50%)',
            width: '20px',
            height: '20px',
            cursor: 'pointer',
        },
    },
    hint: {
        textAlign: 'left',
        fontFamily: theme.palette.common.font,
        fontSize: '12px',
        lineHeight: '16px',
        fontWeight: 400,
        color: theme.palette.common.hintWhite,
        margin: '2px auto 0px',
        width: '40%',
    },
});
